/* @ts-self-types="./fluveria_engine_wasm.d.ts" */

export class ArcCpuSamplerData {
    static __wrap(ptr) {
        const obj = Object.create(ArcCpuSamplerData.prototype);
        obj.__wbg_ptr = ptr;
        ArcCpuSamplerDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ArcCpuSamplerDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_arccpusamplerdata_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    byteLength() {
        const ret = wasm.arccpusamplerdata_byteLength(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} pixel_size
     * @param {number} distance_to_boundary
     * @returns {number}
     */
    coverageAt(x, y, pixel_size, distance_to_boundary) {
        const ret = wasm.arccpusamplerdata_coverageAt(this.__wbg_ptr, x, y, pixel_size, distance_to_boundary);
        return ret;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @returns {number}
     */
    distanceAt(x, y) {
        const ret = wasm.arccpusamplerdata_distanceAt(this.__wbg_ptr, x, y);
        return ret;
    }
}
if (Symbol.dispose) ArcCpuSamplerData.prototype[Symbol.dispose] = ArcCpuSamplerData.prototype.free;

export class ArcGpuBufferData {
    static __wrap(ptr) {
        const obj = Object.create(ArcGpuBufferData.prototype);
        obj.__wbg_ptr = ptr;
        ArcGpuBufferDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ArcGpuBufferDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_arcgpubufferdata_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array}
     */
    meta() {
        const ret = wasm.arcgpubufferdata_meta(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    windRowIndices() {
        const ret = wasm.arcgpubufferdata_windRowIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) ArcGpuBufferData.prototype[Symbol.dispose] = ArcGpuBufferData.prototype.free;

export class ArcQueryData {
    static __wrap(ptr) {
        const obj = Object.create(ArcQueryData.prototype);
        obj.__wbg_ptr = ptr;
        ArcQueryDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ArcQueryDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_arcquerydata_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    arcs() {
        const ret = wasm.arcquerydata_arcs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    bounds() {
        const ret = wasm.arcquerydata_bounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    bvhLeafIndices() {
        const ret = wasm.arcquerydata_bvhLeafIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    bvhNodeCount() {
        const ret = wasm.arcquerydata_bvhNodeCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    bvhNodeData() {
        const ret = wasm.arcquerydata_bvhNodeData(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    byteLength() {
        const ret = wasm.arcquerydata_byteLength(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Uint32Array}
     */
    contourOffsets() {
        const ret = wasm.arcquerydata_contourOffsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} pixel_size
     * @param {number} distance_to_boundary
     * @returns {number}
     */
    coverageAtWithDistance(x, y, pixel_size, distance_to_boundary) {
        const ret = wasm.arcquerydata_coverageAtWithDistance(this.__wbg_ptr, x, y, pixel_size, distance_to_boundary);
        return ret;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} pixel_size
     * @returns {number}
     */
    coverageAt(x, y, pixel_size) {
        const ret = wasm.arcquerydata_coverageAt(this.__wbg_ptr, x, y, pixel_size);
        return ret;
    }
    /**
     * @returns {ArcCpuSamplerData}
     */
    cpuSamplerData() {
        const ret = wasm.arcquerydata_cpuSamplerData(this.__wbg_ptr);
        return ArcCpuSamplerData.__wrap(ret);
    }
    /**
     * @returns {Float32Array}
     */
    distArcs() {
        const ret = wasm.arcquerydata_distArcs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    distCount() {
        const ret = wasm.arcquerydata_distCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @returns {number}
     */
    distanceAt(x, y) {
        const ret = wasm.arcquerydata_distanceAt(this.__wbg_ptr, x, y);
        return ret;
    }
    /**
     * @param {number} slot_index
     * @returns {ArcGpuBufferData}
     */
    gpuBufferData(slot_index) {
        const ret = wasm.arcquerydata_gpuBufferData(this.__wbg_ptr, slot_index);
        return ArcGpuBufferData.__wrap(ret);
    }
    /**
     * The arcs with the arc-length table in their tail -- what binding 2 must
     * carry for `arc_length_at` to find it. See `ArcQuery::gpu_dist_arcs`.
     * @returns {Float32Array}
     */
    gpuDistArcs() {
        const ret = wasm.arcquerydata_gpuDistArcs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    rowCount() {
        const ret = wasm.arcquerydata_rowCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    rowSize() {
        const ret = wasm.arcquerydata_rowSize(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    windCount() {
        const ret = wasm.arcquerydata_windCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    windMaxSpan() {
        const ret = wasm.arcquerydata_windMaxSpan(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint32Array}
     */
    windRightRowIndices() {
        const ret = wasm.arcquerydata_windRightRowIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    windRightRowSums() {
        const ret = wasm.arcquerydata_windRightRowSums(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    windRowIndices() {
        const ret = wasm.arcquerydata_windRowIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    windRowOffsets() {
        const ret = wasm.arcquerydata_windRowOffsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    windSegs() {
        const ret = wasm.arcquerydata_windSegs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    yMin() {
        const ret = wasm.arcquerydata_yMin(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) ArcQueryData.prototype[Symbol.dispose] = ArcQueryData.prototype.free;

/**
 * The engine's interaction runtime over a document a JS host holds.
 */
export class BehaviorRuntimeHandle {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BehaviorRuntimeHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_behaviorruntimehandle_free(ptr, 0);
    }
    constructor() {
        const ret = wasm.behaviorruntimehandle_new();
        this.__wbg_ptr = ret;
        BehaviorRuntimeHandleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Take the keyboard from the node that holds it (Escape).
     */
    releaseTextFocus() {
        wasm.behaviorruntimehandle_releaseTextFocus(this.__wbg_ptr);
    }
    /**
     * Back to nothing: every spring at rest, every node's outputs gone, the
     * press and the keyboard let go -- what a document is when it starts
     * running again. The document stays.
     */
    reset() {
        wasm.behaviorruntimehandle_reset(this.__wbg_ptr);
    }
    /**
     * Hand the runtime the document, as the editor snapshot the host saves
     * (`serializeDocumentWasm` takes the same): on opening it, and on every
     * edit. What a node the edit kept was doing goes on; a node it removed
     * is forgotten.
     * @param {any} snapshot
     */
    setDocument(snapshot) {
        const ret = wasm.behaviorruntimehandle_setDocument(this.__wbg_ptr, snapshot);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * The records of the data source `source_id`, as the host's provider
     * holds them now: what the document's graphs read of it from the next
     * tick on.
     * @param {string} source_id
     * @param {any} records
     */
    setRecords(source_id, records) {
        const ptr0 = passStringToWasm0(source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.behaviorruntimehandle_setRecords(this.__wbg_ptr, ptr0, len0, records);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * [`Self::tick`] over the document's state as `state` holds it -- the
     * state the host's event graphs write -- rather than one of the
     * runtime's own, so that both read and write one.
     * @param {any} input
     * @param {RuntimeStateHandle} state
     * @returns {any}
     */
    tickWithState(input, state) {
        _assertClass(state, RuntimeStateHandle);
        const ret = wasm.behaviorruntimehandle_tickWithState(this.__wbg_ptr, input, state.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * One tick of the document's behaviours; see the module's notes for
     * what goes in and what comes back.
     * @param {any} input
     * @returns {any}
     */
    tick(input) {
        const ret = wasm.behaviorruntimehandle_tick(this.__wbg_ptr, input);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Turn the wheel by `delta` (world units, x across and y down) at
     * `pointer`, over the layout and the session of the last tick: the
     * frames it moves, and the offsets with them moved.
     * @param {any} input
     * @returns {any}
     */
    wheel(input) {
        const ret = wasm.behaviorruntimehandle_wheel(this.__wbg_ptr, input);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
}
if (Symbol.dispose) BehaviorRuntimeHandle.prototype[Symbol.dispose] = BehaviorRuntimeHandle.prototype.free;

export class CompiledShapeData {
    static __wrap(ptr) {
        const obj = Object.create(CompiledShapeData.prototype);
        obj.__wbg_ptr = ptr;
        CompiledShapeDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CompiledShapeDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_compiledshapedata_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    arcs() {
        const ret = wasm.compiledshapedata_arcs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    bounds() {
        const ret = wasm.compiledshapedata_bounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    bvhLeafIndices() {
        const ret = wasm.compiledshapedata_bvhLeafIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    bvhNodeCount() {
        const ret = wasm.compiledshapedata_bvhNodeCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    bvhNodeData() {
        const ret = wasm.compiledshapedata_bvhNodeData(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    byteLength() {
        const ret = wasm.compiledshapedata_byteLength(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    contourBounds() {
        const ret = wasm.compiledshapedata_contourBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    contourOffsets() {
        const ret = wasm.compiledshapedata_contourOffsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} pixel_size
     * @param {number} distance_to_boundary
     * @returns {number}
     */
    coverageAtWithDistance(x, y, pixel_size, distance_to_boundary) {
        const ret = wasm.compiledshapedata_coverageAtWithDistance(this.__wbg_ptr, x, y, pixel_size, distance_to_boundary);
        return ret;
    }
    /**
     * @returns {Float32Array}
     */
    distArcs() {
        const ret = wasm.compiledshapedata_distArcs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    distCount() {
        const ret = wasm.compiledshapedata_distCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @returns {number}
     */
    distanceAt(x, y) {
        const ret = wasm.compiledshapedata_distanceAt(this.__wbg_ptr, x, y);
        return ret;
    }
    /**
     * @param {number} slot_index
     * @returns {ArcGpuBufferData}
     */
    gpuBufferData(slot_index) {
        const ret = wasm.compiledshapedata_gpuBufferData(this.__wbg_ptr, slot_index);
        return ArcGpuBufferData.__wrap(ret);
    }
    /**
     * The arcs with the arc-length table in their tail, which is what the
     * shader's binding 2 must be given: `arc_length_at` reads the table from
     * `distOffset + distCount` onwards. A host that uploads `distArcs` instead
     * has a working distance field and an `ArcLength` that reads whatever
     * follows the arcs in its own buffer.
     * @returns {Float32Array}
     */
    gpuDistArcs() {
        const ret = wasm.compiledshapedata_gpuDistArcs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {boolean}
     */
    hasQuery() {
        const ret = wasm.compiledshapedata_hasQuery(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    key() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.compiledshapedata_key(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float32Array}
     */
    layoutBounds() {
        const ret = wasm.compiledshapedata_layoutBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    leafCount() {
        const ret = wasm.compiledshapedata_leafCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    rowCount() {
        const ret = wasm.compiledshapedata_rowCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    rowSize() {
        const ret = wasm.compiledshapedata_rowSize(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    windCount() {
        const ret = wasm.compiledshapedata_windCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    windMaxSpan() {
        const ret = wasm.compiledshapedata_windMaxSpan(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint32Array}
     */
    windRightRowIndices() {
        const ret = wasm.compiledshapedata_windRightRowIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    windRightRowSums() {
        const ret = wasm.compiledshapedata_windRightRowSums(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    windRowIndices() {
        const ret = wasm.compiledshapedata_windRowIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    windRowOffsets() {
        const ret = wasm.compiledshapedata_windRowOffsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    windSegs() {
        const ret = wasm.compiledshapedata_windSegs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    yMin() {
        const ret = wasm.compiledshapedata_yMin(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) CompiledShapeData.prototype[Symbol.dispose] = CompiledShapeData.prototype.free;

/**
 * A compiled Data Graph shared by any number of keyed runtime instances.
 * Stateful nodes remain independent because their state is stored per key.
 */
export class DataProgramHandle {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DataProgramHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_dataprogramhandle_free(ptr, 0);
    }
    /**
     * @returns {any}
     */
    dependencies() {
        const ret = wasm.dataprogramhandle_dependencies(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} instance_key
     * @returns {boolean}
     */
    dropInstance(instance_key) {
        const ptr0 = passStringToWasm0(instance_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.dataprogramhandle_dropInstance(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
     * @param {string} instance_key
     * @param {any} context
     * @param {DataSourceStoreHandle} data_sources
     * @returns {any}
     */
    evaluateWithSources(instance_key, context, data_sources) {
        const ptr0 = passStringToWasm0(instance_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(data_sources, DataSourceStoreHandle);
        const ret = wasm.dataprogramhandle_evaluateWithSources(this.__wbg_ptr, ptr0, len0, context, data_sources.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} instance_key
     * @param {any} context
     * @param {RuntimeStateHandle} runtime_state
     * @param {DataSourceStoreHandle} data_sources
     * @param {string | null} [owner_key]
     * @returns {any}
     */
    evaluateWithStateAndSources(instance_key, context, runtime_state, data_sources, owner_key) {
        const ptr0 = passStringToWasm0(instance_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(runtime_state, RuntimeStateHandle);
        _assertClass(data_sources, DataSourceStoreHandle);
        var ptr1 = isLikeNone(owner_key) ? 0 : passStringToWasm0(owner_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.dataprogramhandle_evaluateWithStateAndSources(this.__wbg_ptr, ptr0, len0, context, runtime_state.__wbg_ptr, data_sources.__wbg_ptr, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} instance_key
     * @param {any} context
     * @param {RuntimeStateHandle} runtime_state
     * @param {string | null} [owner_key]
     * @returns {any}
     */
    evaluateWithState(instance_key, context, runtime_state, owner_key) {
        const ptr0 = passStringToWasm0(instance_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(runtime_state, RuntimeStateHandle);
        var ptr1 = isLikeNone(owner_key) ? 0 : passStringToWasm0(owner_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.dataprogramhandle_evaluateWithState(this.__wbg_ptr, ptr0, len0, context, runtime_state.__wbg_ptr, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} instance_key
     * @param {any} context
     * @returns {any}
     */
    evaluate(instance_key, context) {
        const ptr0 = passStringToWasm0(instance_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.dataprogramhandle_evaluate(this.__wbg_ptr, ptr0, len0, context);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} config
     */
    constructor(config) {
        const ret = wasm.dataprogramhandle_new(config);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        DataProgramHandleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    reset() {
        wasm.dataprogramhandle_reset(this.__wbg_ptr);
    }
}
if (Symbol.dispose) DataProgramHandle.prototype[Symbol.dispose] = DataProgramHandle.prototype.free;

export class DataSourceStoreHandle {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DataSourceStoreHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_datasourcestorehandle_free(ptr, 0);
    }
    /**
     * The source accepted a mutation at `revision`: it stays laid over the
     * records until they reach that revision, or until a delta or a snapshot
     * names it. Says whether the view changed.
     * @param {string} source_id
     * @param {string} mutation_id
     * @param {number} revision
     * @returns {boolean}
     */
    acknowledge(source_id, mutation_id, revision) {
        const ptr0 = passStringToWasm0(source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(mutation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.datasourcestorehandle_acknowledge(this.__wbg_ptr, ptr0, len0, ptr1, len1, revision);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Apply a delta to the confirmed records; says whether the view changed.
     * The pending mutations it names stop being pending. A delta the
     * confirmed records already include writes nothing and only lets go of
     * what it names; one that starts anywhere else is a revision gap, an
     * error, and the source stale until a snapshot.
     * @param {any} delta
     * @returns {boolean}
     */
    applyDelta(delta) {
        const ret = wasm.datasourcestorehandle_applyDelta(this.__wbg_ptr, delta);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {string} source_id
     * @returns {boolean}
     */
    close(source_id) {
        const ptr0 = passStringToWasm0(source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datasourcestorehandle_close(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    constructor() {
        const ret = wasm.datasourcestorehandle_new();
        this.__wbg_ptr = ret;
        DataSourceStoreHandleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * The source's mutations not yet confirmed, oldest first:
     * `{ mutationId, operations, acceptedAt? }`.
     * @param {string} source_id
     * @returns {any}
     */
    pending(source_id) {
        const ptr0 = passStringToWasm0(source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datasourcestorehandle_pending(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Lay a local mutation over the source's records at once, ahead of the
     * source's answer; says whether the view changed. `operations` are in
     * the shape a reader sees -- field ids, projected records -- and their
     * numbers are spelled as the project's data spells them.
     * @param {string} source_id
     * @param {string} mutation_id
     * @param {any} operations
     * @returns {boolean}
     */
    pushPending(source_id, mutation_id, operations) {
        const ptr0 = passStringToWasm0(source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(mutation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.datasourcestorehandle_pushPending(this.__wbg_ptr, ptr0, len0, ptr1, len1, operations);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * What a reader sees of the source: the confirmed records with every
     * pending mutation replayed over them, in the order it was made.
     * `undefined` for a source with no snapshot.
     * @param {string} source_id
     * @returns {any}
     */
    records(source_id) {
        const ptr0 = passStringToWasm0(source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datasourcestorehandle_records(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * The source refused a mutation, or it never reached the source: take
     * it out of the view as if it had never been made. Says whether the view
     * changed.
     * @param {string} source_id
     * @param {string} mutation_id
     * @returns {boolean}
     */
    reject(source_id, mutation_id) {
        const ptr0 = passStringToWasm0(source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(mutation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.datasourcestorehandle_reject(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret !== 0;
    }
    /**
     * Take a whole snapshot as the source's confirmed records. The pending
     * mutations stay laid over it, except those it names (`mutationIds`) and
     * those accepted at a revision it has reached.
     * @param {any} snapshot
     */
    replaceSnapshot(snapshot) {
        const ret = wasm.datasourcestorehandle_replaceSnapshot(this.__wbg_ptr, snapshot);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} source_id
     * @returns {any}
     */
    status(source_id) {
        const ptr0 = passStringToWasm0(source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datasourcestorehandle_status(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
}
if (Symbol.dispose) DataSourceStoreHandle.prototype[Symbol.dispose] = DataSourceStoreHandle.prototype.free;

export class EventProgramHandle {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        EventProgramHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_eventprogramhandle_free(ptr, 0);
    }
    /**
     * @param {RuntimeStateHandle} runtime_state
     * @param {any} invocation
     * @returns {any}
     */
    dispatch(runtime_state, invocation) {
        _assertClass(runtime_state, RuntimeStateHandle);
        const ret = wasm.eventprogramhandle_dispatch(this.__wbg_ptr, runtime_state.__wbg_ptr, invocation);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Payload field names an event declares, or `undefined` if there is no
     * such event. A payload is validated for an exact key match, so a host
     * that guesses a field fails the whole dispatch — it has to ask.
     * @param {string} name
     * @returns {any}
     */
    eventFields(name) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.eventprogramhandle_eventFields(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} name
     * @returns {boolean}
     */
    hasEvent(name) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.eventprogramhandle_hasEvent(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
     * @param {any} config
     * @param {RuntimeStateHandle} runtime_state
     */
    constructor(config, runtime_state) {
        _assertClass(runtime_state, RuntimeStateHandle);
        const ret = wasm.eventprogramhandle_new(config, runtime_state.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        EventProgramHandleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) EventProgramHandle.prototype[Symbol.dispose] = EventProgramHandle.prototype.free;

/**
 * Graph runtime handle: parsed graphs + plans + render settings live in
 * Rust; the frontend pushes params once per frame and the compiled shape
 * whenever its shape compiler produces a new result, then samples
 * geometry/material per point.
 */
export class GraphRuntimeHandle {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GraphRuntimeHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_graphruntimehandle_free(ptr, 0);
    }
    clearCompiledShape() {
        wasm.graphruntimehandle_clearCompiledShape(this.__wbg_ptr);
    }
    /**
     * @param {string} render_slot
     * @returns {number}
     */
    dynamicDrawBoundsDilationPx(render_slot) {
        const ptr0 = passStringToWasm0(render_slot, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.graphruntimehandle_dynamicDrawBoundsDilationPx(this.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} layer_w
     * @param {number} layer_h
     * @param {any} frame
     * @returns {any}
     */
    geometry(x, y, layer_w, layer_h, frame) {
        const ret = wasm.graphruntimehandle_geometry(this.__wbg_ptr, x, y, layer_w, layer_h, frame);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * `world_scale_x`/`world_scale_y` are the layer's framebuffer pixels per
     * shape unit, the same numbers the caller hands `syncShape`. A host that
     * passes 0 or a non-finite value gets the scale-1 reading this took
     * before the arguments existed.
     * @param {number} allocated_w
     * @param {number} allocated_h
     * @param {number} world_scale_x
     * @param {number} world_scale_y
     * @returns {Float64Array}
     */
    materialDrawBounds(allocated_w, allocated_h, world_scale_x, world_scale_y) {
        const ret = wasm.graphruntimehandle_materialDrawBounds(this.__wbg_ptr, allocated_w, allocated_h, world_scale_x, world_scale_y);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} layer_w
     * @param {number} layer_h
     * @param {any} frame
     * @returns {any}
     */
    material(x, y, layer_w, layer_h, frame) {
        const ret = wasm.graphruntimehandle_material(this.__wbg_ptr, x, y, layer_w, layer_h, frame);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Float64Array}
     */
    measure() {
        const ret = wasm.graphruntimehandle_measure(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @param {any} config
     */
    constructor(config) {
        const ret = wasm.graphruntimehandle_new(config);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        GraphRuntimeHandleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Install the compiled shape from raw query arcs (the frontend's shape
     * compiler output). Pass empty arcs to clear the sampler (compile error
     * or empty graph) while keeping bounds.
     * @param {Float32Array} arcs
     * @param {Uint32Array} contour_offsets
     * @param {boolean} has_query
     * @param {Float64Array} layout_bounds
     * @param {Float64Array} contour_bounds
     */
    setCompiledShapeFromArcs(arcs, contour_offsets, has_query, layout_bounds, contour_bounds) {
        const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray32ToWasm0(contour_offsets, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passArrayF64ToWasm0(layout_bounds, wasm.__wbindgen_malloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passArrayF64ToWasm0(contour_bounds, wasm.__wbindgen_malloc);
        const len3 = WASM_VECTOR_LEN;
        wasm.graphruntimehandle_setCompiledShapeFromArcs(this.__wbg_ptr, ptr0, len0, ptr1, len1, has_query, ptr2, len2, ptr3, len3);
    }
    /**
     * The document's lamps (`fluveria_graph::light::Light`, as the document
     * writes them), which a material's `Illuminance` nodes sum over: the
     * canvas path lights a layer as the GPU path does. An empty list, or
     * none, lights nothing.
     * @param {any} lights
     */
    setLights(lights) {
        const ret = wasm.graphruntimehandle_setLights(this.__wbg_ptr, lights);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {any} params
     */
    setParams(params) {
        const ret = wasm.graphruntimehandle_setParams(this.__wbg_ptr, params);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
}
if (Symbol.dispose) GraphRuntimeHandle.prototype[Symbol.dispose] = GraphRuntimeHandle.prototype.free;

export class LayerShaderResult {
    static __wrap(ptr) {
        const obj = Object.create(LayerShaderResult.prototype);
        obj.__wbg_ptr = ptr;
        LayerShaderResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LayerShaderResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_layershaderresult_free(ptr, 0);
    }
    /**
     * `{ key, index }[]` — arc geometry slots referenced by the shader.
     * @returns {any}
     */
    arcSlots() {
        const ret = wasm.layershaderresult_arcSlots(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Float32Array}
     */
    contourBounds() {
        const ret = wasm.layershaderresult_contourBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    layoutBounds() {
        const ret = wasm.layershaderresult_layoutBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string}
     */
    src() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.layershaderresult_src(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Geometry-stage shape compile result — same class
     * `compileShapeGraphWasm` returns; adopt it via the existing
     * `adoptCompiledShapeGraph` path. Callable once.
     * @returns {ShapeGraphCompileResult | undefined}
     */
    takeShapeResult() {
        const ret = wasm.layershaderresult_takeShapeResult(this.__wbg_ptr);
        return ret === 0 ? undefined : ShapeGraphCompileResult.__wrap(ret);
    }
    /**
     * Whether the module reads the document's lamps after its value slots.
     * A host that resolves the slots itself appends
     * [`pack_lights`] of the document's `lights` to the buffer when this is
     * true, as the native plan does; the module reads nothing there
     * otherwise.
     * @returns {boolean}
     */
    usesLights() {
        const ret = wasm.layershaderresult_usesLights(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * `ValueSlot[]` (sans shapeData): `{ key, index, value, paramSource? }`.
     * @returns {any}
     */
    valueSlots() {
        const ret = wasm.layershaderresult_valueSlots(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
}
if (Symbol.dispose) LayerShaderResult.prototype[Symbol.dispose] = LayerShaderResult.prototype.free;

export class QueryProgramHandle {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        QueryProgramHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_queryprogramhandle_free(ptr, 0);
    }
    /**
     * @returns {any}
     */
    dependencies() {
        const ret = wasm.queryprogramhandle_dependencies(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {DataSourceStoreHandle} sources
     * @param {RuntimeStateHandle} runtime_state
     * @param {string | null | undefined} owner_key
     * @param {any} inputs
     * @returns {any}
     */
    evaluateWithState(sources, runtime_state, owner_key, inputs) {
        _assertClass(sources, DataSourceStoreHandle);
        _assertClass(runtime_state, RuntimeStateHandle);
        var ptr0 = isLikeNone(owner_key) ? 0 : passStringToWasm0(owner_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.queryprogramhandle_evaluateWithState(this.__wbg_ptr, sources.__wbg_ptr, runtime_state.__wbg_ptr, ptr0, len0, inputs);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {DataSourceStoreHandle} sources
     * @returns {any}
     */
    evaluate(sources) {
        _assertClass(sources, DataSourceStoreHandle);
        const ret = wasm.queryprogramhandle_evaluate(this.__wbg_ptr, sources.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} config
     */
    constructor(config) {
        const ret = wasm.queryprogramhandle_new(config);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        QueryProgramHandleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) QueryProgramHandle.prototype[Symbol.dispose] = QueryProgramHandle.prototype.free;

/**
 * Session-only typed values. The document provides its schema, while this
 * handle owns the mutable values and explicit snapshot boundary.
 */
export class RuntimeStateHandle {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RuntimeStateHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_runtimestatehandle_free(ptr, 0);
    }
    /**
     * @returns {any}
     */
    exportSnapshot() {
        const ret = wasm.runtimestatehandle_exportSnapshot(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string | null} [owner_key]
     * @returns {any}
     */
    inspectorSnapshot(owner_key) {
        var ptr0 = isLikeNone(owner_key) ? 0 : passStringToWasm0(owner_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.runtimestatehandle_inspectorSnapshot(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} schema
     */
    constructor(schema) {
        const ret = wasm.runtimestatehandle_new(schema);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        RuntimeStateHandleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {string} name
     * @param {string | null} [owner_key]
     * @returns {any}
     */
    read(name, owner_key) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(owner_key) ? 0 : passStringToWasm0(owner_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.runtimestatehandle_read(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    reset() {
        wasm.runtimestatehandle_reset(this.__wbg_ptr);
    }
    /**
     * @param {any} snapshot
     */
    restoreSnapshot(snapshot) {
        const ret = wasm.runtimestatehandle_restoreSnapshot(this.__wbg_ptr, snapshot);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
}
if (Symbol.dispose) RuntimeStateHandle.prototype[Symbol.dispose] = RuntimeStateHandle.prototype.free;

/**
 * CPU scene render framebuffer: one wasm call per layer instead of two
 * per pixel. Can persist across frames for dirty-rect repaints
 * (`clearRect` + `readRect`); `finish` returns the full RGBA8 buffer.
 */
export class ScenePainter {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScenePainterFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scenepainter_free(ptr, 0);
    }
    /**
     * @param {number} x0
     * @param {number} y0
     * @param {number} x1
     * @param {number} y1
     */
    clearRect(x0, y0, x1, y1) {
        wasm.scenepainter_clearRect(this.__wbg_ptr, x0, y0, x1, y1);
    }
    /**
     * @returns {Uint8Array}
     */
    finish() {
        const ret = wasm.scenepainter_finish(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {any} settings
     */
    constructor(settings) {
        const ret = wasm.scenepainter_new(settings);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        ScenePainterFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {GraphRuntimeHandle} runtime
     * @param {any} args
     */
    paintLayer(runtime, args) {
        _assertClass(runtime, GraphRuntimeHandle);
        const ret = wasm.scenepainter_paintLayer(this.__wbg_ptr, runtime.__wbg_ptr, args);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} x0
     * @param {number} y0
     * @param {number} x1
     * @param {number} y1
     * @returns {Uint8Array}
     */
    readRect(x0, y0, x1, y1) {
        const ret = wasm.scenepainter_readRect(this.__wbg_ptr, x0, y0, x1, y1);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
}
if (Symbol.dispose) ScenePainter.prototype[Symbol.dispose] = ScenePainter.prototype.free;

export class ShapeGraphCompileResult {
    static __wrap(ptr) {
        const obj = Object.create(ShapeGraphCompileResult.prototype);
        obj.__wbg_ptr = ptr;
        ShapeGraphCompileResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ShapeGraphCompileResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_shapegraphcompileresult_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    contourBounds() {
        const ret = wasm.shapegraphcompileresult_contourBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string | undefined}
     */
    error() {
        const ret = wasm.shapegraphcompileresult_error(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]);
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * Whether the compiled shape carries a sampleable query (TS rule:
     * hasQuery AND bounds AND distCount > 0).
     * @returns {boolean}
     */
    hasQuery() {
        const ret = wasm.shapegraphcompileresult_hasQuery(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    key() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.shapegraphcompileresult_key(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float32Array}
     */
    layoutBounds() {
        const ret = wasm.shapegraphcompileresult_layoutBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {CompiledShapeData | undefined}
     */
    takeCompiled() {
        const ret = wasm.shapegraphcompileresult_takeCompiled(this.__wbg_ptr);
        return ret === 0 ? undefined : CompiledShapeData.__wrap(ret);
    }
}
if (Symbol.dispose) ShapeGraphCompileResult.prototype[Symbol.dispose] = ShapeGraphCompileResult.prototype.free;

export class ShapeLeafHandleData {
    static __wrap(ptr) {
        const obj = Object.create(ShapeLeafHandleData.prototype);
        obj.__wbg_ptr = ptr;
        ShapeLeafHandleDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ShapeLeafHandleDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_shapeleafhandledata_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    byteLength() {
        const ret = wasm.shapeleafhandledata_byteLength(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    contourBounds() {
        const ret = wasm.shapeleafhandledata_contourBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    id() {
        const ret = wasm.shapeleafhandledata_id(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */
    key() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.shapeleafhandledata_key(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float32Array}
     */
    layoutBounds() {
        const ret = wasm.shapeleafhandledata_layoutBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    release() {
        wasm.shapeleafhandledata_release(this.__wbg_ptr);
    }
}
if (Symbol.dispose) ShapeLeafHandleData.prototype[Symbol.dispose] = ShapeLeafHandleData.prototype.free;

export class ShapeTreePlanData {
    static __wrap(ptr) {
        const obj = Object.create(ShapeTreePlanData.prototype);
        obj.__wbg_ptr = ptr;
        ShapeTreePlanDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ShapeTreePlanDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_shapetreeplandata_free(ptr, 0);
    }
    /**
     * @returns {ArcQueryData}
     */
    arcQueryData() {
        const ret = wasm.shapetreeplandata_arcQueryData(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ArcQueryData.__wrap(ret[0]);
    }
    /**
     * @returns {Float32Array}
     */
    contourBounds() {
        const ret = wasm.shapetreeplandata_contourBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    exprOps() {
        const ret = wasm.shapetreeplandata_exprOps(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string}
     */
    key() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.shapetreeplandata_key(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Float32Array}
     */
    layoutBounds() {
        const ret = wasm.shapetreeplandata_layoutBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    leafCount() {
        const ret = wasm.shapetreeplandata_leafCount(this.__wbg_ptr);
        return ret >>> 0;
    }
}
if (Symbol.dispose) ShapeTreePlanData.prototype[Symbol.dispose] = ShapeTreePlanData.prototype.free;

export class TextParagraphArcQueryData {
    static __wrap(ptr) {
        const obj = Object.create(TextParagraphArcQueryData.prototype);
        obj.__wbg_ptr = ptr;
        TextParagraphArcQueryDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TextParagraphArcQueryDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_textparagrapharcquerydata_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    arcs() {
        const ret = wasm.textparagrapharcquerydata_arcs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    bounds() {
        const ret = wasm.textparagrapharcquerydata_bounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    bvhLeafIndices() {
        const ret = wasm.textparagrapharcquerydata_bvhLeafIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    bvhNodeCount() {
        const ret = wasm.textparagrapharcquerydata_bvhNodeCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    bvhNodeData() {
        const ret = wasm.textparagrapharcquerydata_bvhNodeData(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    contourOffsets() {
        const ret = wasm.textparagrapharcquerydata_contourOffsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {ArcCpuSamplerData}
     */
    cpuSamplerData() {
        const ret = wasm.textparagrapharcquerydata_cpuSamplerData(this.__wbg_ptr);
        return ArcCpuSamplerData.__wrap(ret);
    }
    /**
     * @returns {Float32Array}
     */
    distArcs() {
        const ret = wasm.textparagrapharcquerydata_distArcs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    distCount() {
        const ret = wasm.textparagrapharcquerydata_distCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    glyphCount() {
        const ret = wasm.textparagrapharcquerydata_glyphCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} slot_index
     * @returns {ArcGpuBufferData}
     */
    gpuBufferData(slot_index) {
        const ret = wasm.textparagrapharcquerydata_gpuBufferData(this.__wbg_ptr, slot_index);
        return ArcGpuBufferData.__wrap(ret);
    }
    /**
     * @returns {Float32Array}
     */
    layoutBounds() {
        const ret = wasm.textparagrapharcquerydata_layoutBounds(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    lineCount() {
        const ret = wasm.textparagrapharcquerydata_lineCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    rowCount() {
        const ret = wasm.textparagrapharcquerydata_rowCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    rowSize() {
        const ret = wasm.textparagrapharcquerydata_rowSize(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    windCount() {
        const ret = wasm.textparagrapharcquerydata_windCount(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    windMaxSpan() {
        const ret = wasm.textparagrapharcquerydata_windMaxSpan(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint32Array}
     */
    windRightRowIndices() {
        const ret = wasm.textparagrapharcquerydata_windRightRowIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    windRightRowSums() {
        const ret = wasm.textparagrapharcquerydata_windRightRowSums(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    windRowIndices() {
        const ret = wasm.textparagrapharcquerydata_windRowIndices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    windRowOffsets() {
        const ret = wasm.textparagrapharcquerydata_windRowOffsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    windSegs() {
        const ret = wasm.textparagrapharcquerydata_windSegs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    yMin() {
        const ret = wasm.textparagrapharcquerydata_yMin(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) TextParagraphArcQueryData.prototype[Symbol.dispose] = TextParagraphArcQueryData.prototype.free;

/**
 * @returns {string}
 */
export function arcSdfWgslWasm() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.arcSdfWgslWasm();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {any} layout
 * @param {any} child_props
 * @param {any} allocated_size
 * @returns {any}
 */
export function arrangeFrameLayout(layout, child_props, allocated_size) {
    const ret = wasm.arrangeFrameLayout(layout, child_props, allocated_size);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Convert one reusable asset-backed Shape node into editable Path node data.
 * Placement uses the same viewBox, fit and alignment implementation as the
 * renderer, so replacing the source node does not move its visible contour.
 * @param {any} input
 * @param {string} node_id
 * @returns {any}
 */
export function bakeSvgShapeNodeWasm(input, node_id) {
    const ptr0 = passStringToWasm0(node_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.bakeSvgShapeNodeWasm(input, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * @param {Float32Array} arcs
 * @param {Uint32Array} contour_offsets
 * @param {Uint32Array} leaf_contour_offsets
 * @param {Uint8Array} leaf_fill_rules
 * @param {Uint32Array} expr_ops
 * @param {boolean} flip_y
 * @returns {ArcQueryData}
 */
export function buildArcQueryFromBooleanExprWasm(arcs, contour_offsets, leaf_contour_offsets, leaf_fill_rules, expr_ops, flip_y) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(leaf_contour_offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(leaf_fill_rules, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(expr_ops, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.buildArcQueryFromBooleanExprWasm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, flip_y);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ArcQueryData.__wrap(ret[0]);
}

/**
 * @param {Float32Array} arcs
 * @param {Uint32Array} contour_offsets
 * @param {Uint32Array} leaf_contour_offsets
 * @param {Uint8Array} leaf_fill_rules
 * @param {Float32Array} leaf_transforms
 * @param {Uint32Array} expr_ops
 * @param {boolean} flip_y
 * @param {number} row_origin_y
 * @param {number} row_size
 * @returns {ArcQueryData}
 */
export function buildArcQueryFromBooleanExprWithLeafTransformsAndWindGridWasm(arcs, contour_offsets, leaf_contour_offsets, leaf_fill_rules, leaf_transforms, expr_ops, flip_y, row_origin_y, row_size) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(leaf_contour_offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(leaf_fill_rules, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArrayF32ToWasm0(leaf_transforms, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(expr_ops, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ret = wasm.buildArcQueryFromBooleanExprWithLeafTransformsAndWindGridWasm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, flip_y, row_origin_y, row_size);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ArcQueryData.__wrap(ret[0]);
}

/**
 * @param {Float32Array} arcs
 * @param {Uint32Array} contour_offsets
 * @param {Uint32Array} leaf_contour_offsets
 * @param {Uint8Array} leaf_fill_rules
 * @param {Float32Array} leaf_transforms
 * @param {Uint32Array} expr_ops
 * @param {boolean} flip_y
 * @returns {ArcQueryData}
 */
export function buildArcQueryFromBooleanExprWithLeafTransformsWasm(arcs, contour_offsets, leaf_contour_offsets, leaf_fill_rules, leaf_transforms, expr_ops, flip_y) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(leaf_contour_offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(leaf_fill_rules, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArrayF32ToWasm0(leaf_transforms, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(expr_ops, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ret = wasm.buildArcQueryFromBooleanExprWithLeafTransformsWasm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, flip_y);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ArcQueryData.__wrap(ret[0]);
}

/**
 * @param {Float32Array} arcs
 * @param {Uint32Array} contour_offsets
 * @param {Uint32Array} leaf_contour_offsets
 * @param {Uint8Array} leaf_fill_rules
 * @param {Uint32Array} expr_ops
 * @param {boolean} flip_y
 * @param {number} row_origin_y
 * @param {number} row_size
 * @returns {ArcQueryData}
 */
export function buildArcQueryFromBooleanExprWithWindGridWasm(arcs, contour_offsets, leaf_contour_offsets, leaf_fill_rules, expr_ops, flip_y, row_origin_y, row_size) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(leaf_contour_offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(leaf_fill_rules, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(expr_ops, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.buildArcQueryFromBooleanExprWithWindGridWasm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, flip_y, row_origin_y, row_size);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ArcQueryData.__wrap(ret[0]);
}

/**
 * @param {Float32Array} arcs
 * @param {boolean} flip_y
 * @returns {ArcQueryData}
 */
export function buildArcQueryWasm(arcs, flip_y) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.buildArcQueryWasm(ptr0, len0, flip_y);
    return ArcQueryData.__wrap(ret);
}

/**
 * @param {Float32Array} arcs
 * @param {boolean} flip_y
 * @param {number} row_origin_y
 * @param {number} row_size
 * @returns {ArcQueryData}
 */
export function buildArcQueryWithWindGridWasm(arcs, flip_y, row_origin_y, row_size) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.buildArcQueryWithWindGridWasm(ptr0, len0, flip_y, row_origin_y, row_size);
    return ArcQueryData.__wrap(ret);
}

/**
 * @param {Float32Array} raw_arcs
 * @param {Uint32Array} raw_contour_offsets
 * @param {Uint32Array} raw_leaf_contour_offsets
 * @param {Uint8Array} leaf_kinds
 * @param {Uint8Array} leaf_fill_rules
 * @param {Float32Array} leaf_params
 * @param {Float32Array} leaf_layout_bounds
 * @param {Float32Array} leaf_transforms
 * @param {Uint32Array} leaf_key_offsets
 * @param {Uint8Array} leaf_key_bytes
 * @param {Uint32Array} tree_ops
 * @param {Float32Array} tree_transform_values
 * @param {Uint32Array} tree_transform_key_offsets
 * @param {Uint8Array} tree_transform_key_bytes
 * @param {boolean} use_wind_grid
 * @param {number} row_origin_y
 * @param {number} row_size
 * @returns {ShapeTreePlanData}
 */
export function buildShapeTreePlanWasm(raw_arcs, raw_contour_offsets, raw_leaf_contour_offsets, leaf_kinds, leaf_fill_rules, leaf_params, leaf_layout_bounds, leaf_transforms, leaf_key_offsets, leaf_key_bytes, tree_ops, tree_transform_values, tree_transform_key_offsets, tree_transform_key_bytes, use_wind_grid, row_origin_y, row_size) {
    const ptr0 = passArrayF32ToWasm0(raw_arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(raw_contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(raw_leaf_contour_offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(leaf_kinds, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray8ToWasm0(leaf_fill_rules, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF32ToWasm0(leaf_params, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArrayF32ToWasm0(leaf_layout_bounds, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArrayF32ToWasm0(leaf_transforms, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArray32ToWasm0(leaf_key_offsets, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ptr9 = passArray8ToWasm0(leaf_key_bytes, wasm.__wbindgen_malloc);
    const len9 = WASM_VECTOR_LEN;
    const ptr10 = passArray32ToWasm0(tree_ops, wasm.__wbindgen_malloc);
    const len10 = WASM_VECTOR_LEN;
    const ptr11 = passArrayF32ToWasm0(tree_transform_values, wasm.__wbindgen_malloc);
    const len11 = WASM_VECTOR_LEN;
    const ptr12 = passArray32ToWasm0(tree_transform_key_offsets, wasm.__wbindgen_malloc);
    const len12 = WASM_VECTOR_LEN;
    const ptr13 = passArray8ToWasm0(tree_transform_key_bytes, wasm.__wbindgen_malloc);
    const len13 = WASM_VECTOR_LEN;
    const ret = wasm.buildShapeTreePlanWasm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8, ptr9, len9, ptr10, len10, ptr11, len11, ptr12, len12, ptr13, len13, use_wind_grid, row_origin_y, row_size);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ShapeTreePlanData.__wrap(ret[0]);
}

/**
 * @param {Float32Array} arcs
 * @param {Uint32Array} contour_offsets
 * @param {Float32Array} transform
 * @param {boolean} flip_y
 * @returns {ArcQueryData}
 */
export function buildTransformedArcQueryWasm(arcs, contour_offsets, transform, flip_y) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(transform, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.buildTransformedArcQueryWasm(ptr0, len0, ptr1, len1, ptr2, len2, flip_y);
    return ArcQueryData.__wrap(ret);
}

/**
 * @param {Float32Array} arcs
 * @param {Uint32Array} contour_offsets
 * @param {Float32Array} transform
 * @param {boolean} flip_y
 * @param {number} row_origin_y
 * @param {number} row_size
 * @returns {ArcQueryData}
 */
export function buildTransformedArcQueryWithWindGridWasm(arcs, contour_offsets, transform, flip_y, row_origin_y, row_size) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(transform, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.buildTransformedArcQueryWithWindGridWasm(ptr0, len0, ptr1, len1, ptr2, len2, flip_y, row_origin_y, row_size);
    return ArcQueryData.__wrap(ret);
}

/**
 * Built-in geometry/material libraries (single source for the editor and
 * native renderers; generated from the editor definitions, now canonical).
 * @returns {string}
 */
export function builtinLibrariesJson() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.builtinLibrariesJson();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Check a `.fluveria` document's bytes the way every reader checks one:
 * the whole document, through the validator an edit goes through, reported
 * as `[{severity, site, message}]` rather than thrown.
 *
 * Separate from [`parse_document_bytes_wasm`] because that one answers with
 * the editor snapshot and a snapshot has no room for a report; a host reads
 * the bytes once and asks both.
 * @param {Uint8Array} bytes
 * @returns {any}
 */
export function checkDocumentBytesWasm(bytes) {
    const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.checkDocumentBytesWasm(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

export function clearCompiledShapeCacheWasm() {
    wasm.clearCompiledShapeCacheWasm();
}

export function clearFittedGlyphCacheWasm() {
    wasm.clearFittedGlyphCacheWasm();
}

export function clearLastFitStateWasm() {
    wasm.clearLastFitStateWasm();
}

export function clearRegisteredFontsWasm() {
    wasm.clearRegisteredFontsWasm();
}

export function clearShapeLeafHandlesWasm() {
    wasm.clearShapeLeafHandlesWasm();
}

/**
 * @param {any} input
 * @returns {LayerShaderResult}
 */
export function compileLayerShaderWasm(input) {
    const ret = wasm.compileLayerShaderWasm(input);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return LayerShaderResult.__wrap(ret[0]);
}

/**
 * @param {any} input
 * @returns {ShapeGraphCompileResult}
 */
export function compileShapeGraphWasm(input) {
    const ret = wasm.compileShapeGraphWasm(input);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ShapeGraphCompileResult.__wrap(ret[0]);
}

/**
 * @param {Float32Array} raw_arcs
 * @param {Uint32Array} raw_contour_offsets
 * @param {Uint32Array} raw_leaf_contour_offsets
 * @param {Uint8Array} leaf_kinds
 * @param {Uint8Array} leaf_fill_rules
 * @param {Float32Array} leaf_params
 * @param {Float32Array} leaf_layout_bounds
 * @param {Float32Array} leaf_transforms
 * @param {Uint32Array} leaf_key_offsets
 * @param {Uint8Array} leaf_key_bytes
 * @param {Uint32Array} tree_ops
 * @param {Float32Array} tree_transform_values
 * @param {Uint32Array} tree_transform_key_offsets
 * @param {Uint8Array} tree_transform_key_bytes
 * @param {boolean} use_wind_grid
 * @param {number} row_origin_y
 * @param {number} row_size
 * @returns {CompiledShapeData}
 */
export function compileShapeTreeWasm(raw_arcs, raw_contour_offsets, raw_leaf_contour_offsets, leaf_kinds, leaf_fill_rules, leaf_params, leaf_layout_bounds, leaf_transforms, leaf_key_offsets, leaf_key_bytes, tree_ops, tree_transform_values, tree_transform_key_offsets, tree_transform_key_bytes, use_wind_grid, row_origin_y, row_size) {
    const ptr0 = passArrayF32ToWasm0(raw_arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(raw_contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(raw_leaf_contour_offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(leaf_kinds, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray8ToWasm0(leaf_fill_rules, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF32ToWasm0(leaf_params, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArrayF32ToWasm0(leaf_layout_bounds, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArrayF32ToWasm0(leaf_transforms, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArray32ToWasm0(leaf_key_offsets, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ptr9 = passArray8ToWasm0(leaf_key_bytes, wasm.__wbindgen_malloc);
    const len9 = WASM_VECTOR_LEN;
    const ptr10 = passArray32ToWasm0(tree_ops, wasm.__wbindgen_malloc);
    const len10 = WASM_VECTOR_LEN;
    const ptr11 = passArrayF32ToWasm0(tree_transform_values, wasm.__wbindgen_malloc);
    const len11 = WASM_VECTOR_LEN;
    const ptr12 = passArray32ToWasm0(tree_transform_key_offsets, wasm.__wbindgen_malloc);
    const len12 = WASM_VECTOR_LEN;
    const ptr13 = passArray8ToWasm0(tree_transform_key_bytes, wasm.__wbindgen_malloc);
    const len13 = WASM_VECTOR_LEN;
    const ret = wasm.compileShapeTreeWasm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8, ptr9, len9, ptr10, len10, ptr11, len11, ptr12, len12, ptr13, len13, use_wind_grid, row_origin_y, row_size);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return CompiledShapeData.__wrap(ret[0]);
}

/**
 * @param {Float32Array} raw_arcs
 * @param {Uint32Array} raw_contour_offsets
 * @param {Uint32Array} raw_leaf_contour_offsets
 * @param {Uint8Array} leaf_kinds
 * @param {Uint8Array} leaf_fill_rules
 * @param {Float32Array} leaf_params
 * @param {Float32Array} leaf_layout_bounds
 * @param {Float32Array} leaf_transforms
 * @param {Uint32Array} leaf_key_offsets
 * @param {Uint8Array} leaf_key_bytes
 * @param {Uint32Array} leaf_handles
 * @param {Uint32Array} tree_ops
 * @param {Float32Array} tree_transform_values
 * @param {Uint32Array} tree_transform_key_offsets
 * @param {Uint8Array} tree_transform_key_bytes
 * @param {boolean} use_wind_grid
 * @param {number} row_origin_y
 * @param {number} row_size
 * @returns {CompiledShapeData}
 */
export function compileShapeTreeWithLeafHandlesWasm(raw_arcs, raw_contour_offsets, raw_leaf_contour_offsets, leaf_kinds, leaf_fill_rules, leaf_params, leaf_layout_bounds, leaf_transforms, leaf_key_offsets, leaf_key_bytes, leaf_handles, tree_ops, tree_transform_values, tree_transform_key_offsets, tree_transform_key_bytes, use_wind_grid, row_origin_y, row_size) {
    const ptr0 = passArrayF32ToWasm0(raw_arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(raw_contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(raw_leaf_contour_offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(leaf_kinds, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray8ToWasm0(leaf_fill_rules, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF32ToWasm0(leaf_params, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArrayF32ToWasm0(leaf_layout_bounds, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArrayF32ToWasm0(leaf_transforms, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArray32ToWasm0(leaf_key_offsets, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ptr9 = passArray8ToWasm0(leaf_key_bytes, wasm.__wbindgen_malloc);
    const len9 = WASM_VECTOR_LEN;
    const ptr10 = passArray32ToWasm0(leaf_handles, wasm.__wbindgen_malloc);
    const len10 = WASM_VECTOR_LEN;
    const ptr11 = passArray32ToWasm0(tree_ops, wasm.__wbindgen_malloc);
    const len11 = WASM_VECTOR_LEN;
    const ptr12 = passArrayF32ToWasm0(tree_transform_values, wasm.__wbindgen_malloc);
    const len12 = WASM_VECTOR_LEN;
    const ptr13 = passArray32ToWasm0(tree_transform_key_offsets, wasm.__wbindgen_malloc);
    const len13 = WASM_VECTOR_LEN;
    const ptr14 = passArray8ToWasm0(tree_transform_key_bytes, wasm.__wbindgen_malloc);
    const len14 = WASM_VECTOR_LEN;
    const ret = wasm.compileShapeTreeWithLeafHandlesWasm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8, ptr9, len9, ptr10, len10, ptr11, len11, ptr12, len12, ptr13, len13, ptr14, len14, use_wind_grid, row_origin_y, row_size);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return CompiledShapeData.__wrap(ret[0]);
}

/**
 * @param {string} d
 * @param {boolean} even_odd
 * @param {number} epsilon
 * @returns {ShapeLeafHandleData}
 */
export function compileSvgShapeLeafWasm(d, even_odd, epsilon) {
    const ptr0 = passStringToWasm0(d, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.compileSvgShapeLeafWasm(ptr0, len0, even_odd, epsilon);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ShapeLeafHandleData.__wrap(ret[0]);
}

/**
 * @param {number} font_id
 * @param {string} text
 * @param {number} letter_spacing
 * @param {number} epsilon
 * @param {boolean} auto_width
 * @param {number} width_px
 * @param {boolean} auto_height
 * @param {number} height_px
 * @param {number} font_size_px
 * @param {string} white_space
 * @param {string} horizontal_align
 * @param {string} vertical_align
 * @param {number} line_height
 * @returns {ShapeLeafHandleData}
 */
export function compileTextShapeLeafWasm(font_id, text, letter_spacing, epsilon, auto_width, width_px, auto_height, height_px, font_size_px, white_space, horizontal_align, vertical_align, line_height) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(white_space, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(horizontal_align, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(vertical_align, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.compileTextShapeLeafWasm(font_id, ptr0, len0, letter_spacing, epsilon, auto_width, width_px, auto_height, height_px, font_size_px, ptr1, len1, ptr2, len2, ptr3, len3, line_height);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ShapeLeafHandleData.__wrap(ret[0]);
}

/**
 * @param {any} input
 * @returns {any}
 */
export function computeSceneLayout(input) {
    const ret = wasm.computeSceneLayout(input);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Exposes [`COVERAGE_ROW_ALIGN_EPSILON`] so frontends building row-aligned
 * wind grids use the exact tolerance baked into the generated shader.
 * @returns {number}
 */
export function coverageRowAlignEpsilonWasm() {
    const ret = wasm.coverageRowAlignEpsilonWasm();
    return ret;
}

/**
 * Node kinds accepted by the engine-owned Data Graph evaluator.
 * @returns {string}
 */
export function dataNodeKindsJson() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.dataNodeKindsJson();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {any} graph
 * @param {any} ctx
 * @param {any} params
 * @param {string | null | undefined} graph_id
 * @param {string} slot
 * @returns {any}
 */
export function debugEvalGraphWasm(graph, ctx, params, graph_id, slot) {
    var ptr0 = isLikeNone(graph_id) ? 0 : passStringToWasm0(graph_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(slot, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.debugEvalGraphWasm(graph, ctx, params, ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * The starter's `screens` records in the shape its `data.json` had,
 * `{"screens": [record, ...]}` in key order -- for a host with no `kv`
 * provider yet. Made from the seed, so the data has one copy.
 * @returns {string}
 */
export function defaultTemplateDataJson() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.defaultTemplateDataJson();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * The starter document, canonical v2 text.
 *
 * Templates live once, in the engine's `templates/` directory, and reach the
 * web through this package — the same delivery the built-in libraries and node
 * defaults already use. Two checked-in copies of one document drift, and this
 * one had: the engine's and the web's disagreed on the header shape.
 * @returns {string}
 */
export function defaultTemplateJson() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.defaultTemplateJson();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * The starter's project seed (`kb:task/298`): the records its `kv` source
 * `screens` reads, a line `{"collection", "key", "record"}` each.
 * @returns {string}
 */
export function defaultTemplateSeed() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.defaultTemplateSeed();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {Float32Array} curves
 * @param {number} epsilon
 * @returns {Float32Array}
 */
export function fitBatchWasm(curves, epsilon) {
    const ptr0 = passArrayF32ToWasm0(curves, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fitBatchWasm(ptr0, len0, epsilon);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * Font-aware: fit a single glyph's outline. Returns a flat arc buffer
 * (8 f32 per arc) in font design units.
 *
 * Coordinates use the font/skrifa Y-down convention; clients that render in
 * Y-up space should flip consistently with outline data from
 * `last_fit_cubics()`.
 *
 * `union` merges fitted arc-line contours (requires the `arc-boolean`
 * feature; silently ignored when the feature is absent).
 * @param {Uint8Array} font_bytes
 * @param {number} glyph_id
 * @param {number} epsilon
 * @param {boolean} union
 * @returns {Float32Array}
 */
export function fitGlyphWasm(font_bytes, glyph_id, epsilon, union) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fitGlyphWasm(ptr0, len0, glyph_id, epsilon, union);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {number} font_id
 * @param {string} text
 * @param {number} letter_spacing
 * @param {number} epsilon
 * @param {boolean} auto_width
 * @param {number} width_px
 * @param {boolean} auto_height
 * @param {number} height_px
 * @param {number} font_size_px
 * @param {string} white_space
 * @param {string} horizontal_align
 * @param {string} vertical_align
 * @param {number} line_height
 * @returns {TextParagraphArcQueryData}
 */
export function fitRegisteredParagraphArcQueryWasm(font_id, text, letter_spacing, epsilon, auto_width, width_px, auto_height, height_px, font_size_px, white_space, horizontal_align, vertical_align, line_height) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(white_space, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(horizontal_align, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(vertical_align, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.fitRegisteredParagraphArcQueryWasm(font_id, ptr0, len0, letter_spacing, epsilon, auto_width, width_px, auto_height, height_px, font_size_px, ptr1, len1, ptr2, len2, ptr3, len3, line_height);
    return TextParagraphArcQueryData.__wrap(ret);
}

/**
 * @param {number} font_id
 * @param {string} text
 * @param {number} epsilon
 * @param {boolean} union
 * @param {boolean} flip_y
 * @returns {ArcQueryData}
 */
export function fitRegisteredTextArcQueryWasm(font_id, text, epsilon, union, flip_y) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fitRegisteredTextArcQueryWasm(font_id, ptr0, len0, epsilon, union, flip_y);
    return ArcQueryData.__wrap(ret);
}

/**
 * @param {number} font_id
 * @param {string} text
 * @param {number} epsilon
 * @param {boolean} union
 * @returns {Float32Array}
 */
export function fitRegisteredTextWasm(font_id, text, epsilon, union) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fitRegisteredTextWasm(font_id, ptr0, len0, epsilon, union);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {number} font_id
 * @param {string} text
 * @param {number} letter_spacing
 * @param {number} epsilon
 * @param {boolean} union
 * @param {boolean} flip_y
 * @returns {ArcQueryData}
 */
export function fitRegisteredTextWithSpacingArcQueryWasm(font_id, text, letter_spacing, epsilon, union, flip_y) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fitRegisteredTextWithSpacingArcQueryWasm(font_id, ptr0, len0, letter_spacing, epsilon, union, flip_y);
    return ArcQueryData.__wrap(ret);
}

/**
 * @param {number} font_id
 * @param {string} text
 * @param {number} letter_spacing
 * @param {number} epsilon
 * @param {boolean} union
 * @returns {Float32Array}
 */
export function fitRegisteredTextWithSpacingWasm(font_id, text, letter_spacing, epsilon, union) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fitRegisteredTextWithSpacingWasm(font_id, ptr0, len0, letter_spacing, epsilon, union);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {string} d
 * @param {boolean} even_odd
 * @param {number} epsilon
 * @returns {ArcQueryData}
 */
export function fitSvgArcQueryWasm(d, even_odd, epsilon) {
    const ptr0 = passStringToWasm0(d, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fitSvgArcQueryWasm(ptr0, len0, even_odd, epsilon);
    return ArcQueryData.__wrap(ret);
}

/**
 * SVG-aware: parse a path `d` string and fit every resulting contour.
 * Returns a flat arc buffer (8 f32 per arc). Per-contour offsets are stored
 * in `LAST_OFFSETS` (access via `last_batch_offsets()`).
 * Empty output signals a parse error — callers may re-run `fluveria_shape_svg::parse_path`
 * natively to recover the specific error.
 * @param {string} d
 * @param {boolean} even_odd
 * @param {number} epsilon
 * @returns {Float32Array}
 */
export function fitSvgWasm(d, even_odd, epsilon) {
    const ptr0 = passStringToWasm0(d, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fitSvgWasm(ptr0, len0, even_odd, epsilon);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {Uint8Array} font_bytes
 * @param {string} text
 * @param {number} epsilon
 * @param {boolean} union
 * @param {boolean} flip_y
 * @returns {ArcQueryData}
 */
export function fitTextArcQueryWasm(font_bytes, text, epsilon, union, flip_y) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.fitTextArcQueryWasm(ptr0, len0, ptr1, len1, epsilon, union, flip_y);
    return ArcQueryData.__wrap(ret);
}

/**
 * Text-aware: shape `text` and fit every glyph in the run.
 *
 * Returns a flat arc buffer. Per-glyph layout metadata is stored separately
 * and retrievable via `last_text_glyphs()` with stride=6:
 * `[glyph_id_as_f32, x, y, x_advance, x_offset, y_offset]`.
 *
 * `last_text_glyph_arc_offsets()` returns glyph-to-arc ranges only when
 * `union=false`. With `union=true`, contours can merge across glyphs and the
 * grouping is undefined, so that getter returns an empty array.
 *
 * Y coordinates use HarfBuzz/skrifa Y-down font units. Clients that render in
 * Y-up space should flip on the JS side; Rust keeps these coordinates
 * consistent with outline data from `last_fit_cubics()`.
 * `union` fits positioned glyphs to arc-line contours, then merges overlaps
 * across the scene (requires `arc-boolean`; silently ignored when absent).
 * @param {Uint8Array} font_bytes
 * @param {string} text
 * @param {number} epsilon
 * @param {boolean} union
 * @returns {Float32Array}
 */
export function fitTextWasm(font_bytes, text, epsilon, union) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.fitTextWasm(ptr0, len0, ptr1, len1, epsilon, union);
    var v3 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v3;
}

/**
 * @param {Uint8Array} font_bytes
 * @param {string} text
 * @param {number} letter_spacing
 * @param {number} epsilon
 * @param {boolean} union
 * @param {boolean} flip_y
 * @returns {ArcQueryData}
 */
export function fitTextWithSpacingArcQueryWasm(font_bytes, text, letter_spacing, epsilon, union, flip_y) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.fitTextWithSpacingArcQueryWasm(ptr0, len0, ptr1, len1, letter_spacing, epsilon, union, flip_y);
    return ArcQueryData.__wrap(ret);
}

/**
 * Text-aware fitting with additional tracking in font units.
 *
 * `letter_spacing` is added after each shaped glyph advance before outlines
 * are positioned and optionally unioned. This lets consumers preserve their
 * text layout model while still using whole-run contour union.
 * @param {Uint8Array} font_bytes
 * @param {string} text
 * @param {number} letter_spacing
 * @param {number} epsilon
 * @param {boolean} union
 * @returns {Float32Array}
 */
export function fitTextWithSpacingWasm(font_bytes, text, letter_spacing, epsilon, union) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.fitTextWithSpacingWasm(ptr0, len0, ptr1, len1, letter_spacing, epsilon, union);
    var v3 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v3;
}

/**
 * @param {number} font_id
 * @returns {Float32Array}
 */
export function fontMetricsRegisteredWasm(font_id) {
    const ret = wasm.fontMetricsRegisteredWasm(font_id);
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Return unscaled global font metrics in font units:
 * `[units_per_em, ascender, descender, x_height, cap_height, line_gap]`.
 *
 * Missing optional metrics are `0.0`. Y metrics use the font/skrifa Y-down
 * convention; clients that render in Y-up space should flip consistently with
 * outline data from `last_fit_cubics()`.
 * @param {Uint8Array} font_bytes
 * @returns {Float32Array}
 */
export function fontMetricsWasm(font_bytes) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.fontMetricsWasm(ptr0, len0);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * Node kinds allowed in a Shape Graph (single source: the editor palette
 * derives math/vector graph availability from this; math/vector kinds are
 * static parameters, evaluated once per compile).
 * @returns {string}
 */
export function geometryNodeKindsJson() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.geometryNodeKindsJson();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Return outline bounds for one glyph as `[left, bottom, right, top]` in
 * font units, or `[0, 0, 0, 0]` when the glyph is missing or empty.
 *
 * Coordinates use the font/skrifa Y-down convention; clients that render in
 * Y-up space should flip consistently with outline data from
 * `last_fit_cubics()`.
 * @param {Uint8Array} font_bytes
 * @param {number} glyph_id
 * @returns {Float32Array}
 */
export function glyphBoundsWasm(font_bytes, glyph_id) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.glyphBoundsWasm(ptr0, len0, glyph_id);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @returns {Uint32Array}
 */
export function lastBatchOffsets() {
    const ret = wasm.lastBatchOffsets();
    var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Return the cubic outline input captured by the last font/text/svg fit call.
 *
 * Font/text coordinates use the font/skrifa Y-down convention; clients that
 * render in Y-up space should flip on the JS side.
 * @returns {Float32Array}
 */
export function lastFitCubics() {
    const ret = wasm.lastFitCubics();
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Return arc offsets for the last `fit_text_wasm(..., union=false)` call.
 *
 * Length is `shaped_glyph_count + 1`; element `i` is the first arc for the
 * i-th shaped glyph, and the last element is total arc count. Returns an empty
 * array for `union=true`, because cross-glyph contour merging makes per-glyph
 * grouping undefined.
 * @returns {Uint32Array}
 */
export function lastTextGlyphArcOffsets() {
    const ret = wasm.lastTextGlyphArcOffsets();
    var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Return the last shaped text layout with stride=6:
 * `[glyph_id_as_f32, x, y, x_advance, x_offset, y_offset]`.
 *
 * Coordinates are HarfBuzz/skrifa Y-down font units; clients that render in
 * Y-up space should flip on the JS side.
 * @returns {Float32Array}
 */
export function lastTextGlyphs() {
    const ret = wasm.lastTextGlyphs();
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @param {any} layout
 * @param {any} child_sizes
 * @returns {any}
 */
export function measureFrameLayout(layout, child_sizes) {
    const ret = wasm.measureFrameLayout(layout, child_sizes);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Per-node-type data defaults (single source: the editor injects these into
 * its node definitions; the v2 codec omits data fields equal to them).
 * @returns {string}
 */
export function nodeDefaultsJson() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.nodeDefaultsJson();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {string}
 */
export function noiseUtilsWgslWasm() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.noiseUtilsWgslWasm();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Pack the per-draw render context for the shader uniform buffer.
 * @param {any} input
 * @returns {Float32Array}
 */
export function packLayerUniformsWasm(input) {
    const ret = wasm.packLayerUniformsWasm(input);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * A document's `lights` as a module that reads them wants them after its
 * value slots (`fluveria_graph::light::pack_lights`): one `vec4` with the
 * count, then two per lamp.
 * @param {any} lights
 * @returns {Float32Array}
 */
export function packLights(lights) {
    const ret = wasm.packLights(lights);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Parse a `.fluveria` document (binary container or v2 text, auto-detected)
 * into the editor snapshot JSON shape (`{id, params, scene, components,
 * layers, favorites, geometry, materials, workspace}`).
 * @param {Uint8Array} bytes
 * @returns {any}
 */
export function parseDocumentBytesWasm(bytes) {
    const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parseDocumentBytesWasm(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Text-only variant of [`parse_document_bytes_wasm`].
 * @param {string} text
 * @returns {any}
 */
export function parseDocumentWasm(text) {
    const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parseDocumentWasm(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * @param {any} input
 * @returns {any}
 */
export function pickScene(input) {
    const ret = wasm.pickScene(input);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Per-layer paint plan (canvas backend pass-1 math; see
 * fluveria_scene::layer_paint).
 * @param {any} input
 * @returns {any}
 */
export function planLayerPaint(input) {
    const ret = wasm.planLayerPaint(input);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Return the default font-unit quality ladder used by cache-aware callers.
 *
 * Callers should first compute their requested font-unit error budget, then
 * use `resolve_quality_epsilon_wasm` before fitting and before building cache
 * keys. The resolver always returns a value no larger than the requested
 * epsilon for finite positive inputs.
 * @returns {Float32Array}
 */
export function qualityProfileEpsilonsWasm() {
    const ret = wasm.qualityProfileEpsilonsWasm();
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @param {Uint8Array} font_bytes
 * @returns {number}
 */
export function registerFontWasm(font_bytes) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.registerFontWasm(ptr0, len0);
    return ret >>> 0;
}

/**
 * @param {Float32Array} arcs
 * @param {Uint32Array} contour_offsets
 * @param {Uint32Array} leaf_contour_offsets
 * @param {Uint8Array} leaf_fill_rules
 * @param {Uint32Array} expr_ops
 * @returns {Float32Array}
 */
export function resolveArcBooleanWasm(arcs, contour_offsets, leaf_contour_offsets, leaf_fill_rules, expr_ops) {
    const ptr0 = passArrayF32ToWasm0(arcs, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(contour_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(leaf_contour_offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(leaf_fill_rules, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(expr_ops, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.resolveArcBooleanWasm(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v6 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v6;
}

/**
 * Convert a pixel error budget to font units and resolve it to quality epsilon.
 * @param {number} units_per_em
 * @param {number} font_size_px
 * @param {number} target_px_error
 * @returns {number}
 */
export function resolveQualityEpsilonForPixelErrorWasm(units_per_em, font_size_px, target_px_error) {
    const ret = wasm.resolveQualityEpsilonForPixelErrorWasm(units_per_em, font_size_px, target_px_error);
    return ret;
}

/**
 * Resolve a requested font-unit epsilon to the cacheable quality epsilon.
 *
 * This snaps down to the nearest default quality level. When the requested
 * epsilon is smaller than the first quality level, the exact requested value
 * is returned so the error budget is still respected.
 * @param {number} requested_epsilon
 * @returns {number}
 */
export function resolveQualityEpsilonWasm(requested_epsilon) {
    const ret = wasm.resolveQualityEpsilonWasm(requested_epsilon);
    return ret;
}

/**
 * @param {number} pixels_per_shape_unit
 * @returns {number}
 */
export function sdfDistanceDensityWasm(pixels_per_shape_unit) {
    const ret = wasm.sdfDistanceDensityWasm(pixels_per_shape_unit);
    return ret;
}

/**
 * @param {number} aa_width_px
 * @param {number} pixels_per_shape_unit
 * @param {number} distance_density
 * @returns {number}
 */
export function sdfFeatherWidthWasm(aa_width_px, pixels_per_shape_unit, distance_density) {
    const ret = wasm.sdfFeatherWidthWasm(aa_width_px, pixels_per_shape_unit, distance_density);
    return ret;
}

/**
 * Serialize the editor snapshot JSON into the binary container — the
 * canonical on-disk form.
 * @param {any} snapshot
 * @returns {Uint8Array}
 */
export function serializeDocumentBinaryWasm(snapshot) {
    const ret = wasm.serializeDocumentBinaryWasm(snapshot);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v1;
}

/**
 * Serialize the editor snapshot JSON into canonical v2 json-tree text.
 * @param {any} snapshot
 * @returns {string}
 */
export function serializeDocumentWasm(snapshot) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ret = wasm.serializeDocumentWasm(snapshot);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * The singular values `(sigma_max, sigma_min)` of a layer's screen-to-layer
 * 2x2, as `shape_sigma` in the uniform block wants them.
 *
 * Exported rather than left to the host because these are not the column
 * norms the host already has: a column norm is a singular value only while
 * `JᵀJ` is diagonal, and a rotation inside an anisotropic scale is not. The
 * host would have to re-derive the formula to get them, and `sigma_min` comes
 * out of a difference of nearly equal numbers, which is exactly the
 * derivation not to have two copies of.
 *
 * Arguments are the screen-to-layer 2x2 in COLUMN-MAJOR order --
 * `(m00, m10, m01, m11)`, the same order `LayerPaintArgs::to_local` carries
 * and not the order the uniform block's `m` does, which interleaves the rows.
 * A degenerate matrix reads as scale 1, the same fiction the engine's own
 * painter takes.
 * @param {number} a
 * @param {number} b
 * @param {number} c
 * @param {number} d
 * @returns {Float64Array}
 */
export function shapeSigmaWasm(a, b, c, d) {
    const ret = wasm.shapeSigmaWasm(a, b, c, d);
    var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
    return v1;
}

/**
 * Shape text without fitting arcs. Returns stride=6 layout:
 * `[glyph_id_as_f32, x, y, x_advance, x_offset, y_offset]`.
 *
 * Coordinates are HarfBuzz/skrifa Y-down font units; clients that render in
 * Y-up space should flip on the JS side.
 * @param {Uint8Array} font_bytes
 * @param {string} text
 * @returns {Float32Array}
 */
export function shapeTextWasm(font_bytes, text) {
    const ptr0 = passArray8ToWasm0(font_bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.shapeTextWasm(ptr0, len0, ptr1, len1);
    var v3 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v3;
}

/**
 * Validate raw SVG path data and return its authored-coordinate bounds.
 * @param {string} d
 * @returns {any}
 */
export function svgPathInfoWasm(d) {
    const ptr0 = passStringToWasm0(d, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.svgPathInfoWasm(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * @param {number} font_id
 * @returns {boolean}
 */
export function unregisterFontWasm(font_id) {
    const ret = wasm.unregisterFontWasm(font_id);
    return ret !== 0;
}

/**
 * Structurally parse and semantically validate an editor snapshot using the
 * canonical v2 document validator.
 * @param {any} snapshot
 * @returns {any}
 */
export function validateDocumentSnapshotWasm(snapshot) {
    const ret = wasm.validateDocumentSnapshotWasm(snapshot);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_Error_30c8987f7c2ed4e2: function(arg0, arg1) {
            const ret = Error(getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_Number_14af1003b8dd5ead: function(arg0) {
            const ret = Number(arg0);
            return ret;
        },
        __wbg_String_8564e559799eccda: function(arg0, arg1) {
            const ret = String(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_bigint_get_as_i64_a2383202b9353e4c: function(arg0, arg1) {
            const v = arg1;
            const ret = typeof(v) === 'bigint' ? v : undefined;
            getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_boolean_get_5b446f51afd21013: function(arg0) {
            const v = arg0;
            const ret = typeof(v) === 'boolean' ? v : undefined;
            return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
        },
        __wbg___wbindgen_debug_string_4687d8d8c2017d52: function(arg0, arg1) {
            const ret = debugString(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_in_92f62ee1427d9e49: function(arg0, arg1) {
            const ret = arg0 in arg1;
            return ret;
        },
        __wbg___wbindgen_is_bigint_b123553bed3bb382: function(arg0) {
            const ret = typeof(arg0) === 'bigint';
            return ret;
        },
        __wbg___wbindgen_is_function_1f9d30630b8b1d3d: function(arg0) {
            const ret = typeof(arg0) === 'function';
            return ret;
        },
        __wbg___wbindgen_is_null_e343b7d08827ba72: function(arg0) {
            const ret = arg0 === null;
            return ret;
        },
        __wbg___wbindgen_is_object_3c45d4f2dde4e749: function(arg0) {
            const val = arg0;
            const ret = typeof(val) === 'object' && val !== null;
            return ret;
        },
        __wbg___wbindgen_is_string_90b56bc79aad6f6c: function(arg0) {
            const ret = typeof(arg0) === 'string';
            return ret;
        },
        __wbg___wbindgen_is_undefined_8865fb403f8fe9d8: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_jsval_eq_02babf21faa37971: function(arg0, arg1) {
            const ret = arg0 === arg1;
            return ret;
        },
        __wbg___wbindgen_jsval_loose_eq_677f21e468d6b461: function(arg0, arg1) {
            const ret = arg0 == arg1;
            return ret;
        },
        __wbg___wbindgen_number_get_2e0e7dee9f701a71: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'number' ? obj : undefined;
            getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_string_get_0380ccaa2f57f0d9: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'string' ? obj : undefined;
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_throw_41e9ee4f547fc59a: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg_call_6137034ef55c9d0f: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.call(arg1);
            return ret;
        }, arguments); },
        __wbg_done_b41a1d26cdb37fb6: function(arg0) {
            const ret = arg0.done;
            return ret;
        },
        __wbg_entries_fb6397112b1de25f: function(arg0) {
            const ret = Object.entries(arg0);
            return ret;
        },
        __wbg_getRandomValues_436a51d0629d84e1: function() { return handleError(function (arg0, arg1) {
            globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
        }, arguments); },
        __wbg_get_658f6698067d9515: function() { return handleError(function (arg0, arg1) {
            const ret = Reflect.get(arg0, arg1);
            return ret;
        }, arguments); },
        __wbg_get_6c896e0571ddae51: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_unchecked_288889d017702237: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_with_ref_key_6412cf3094599694: function(arg0, arg1) {
            const ret = arg0[arg1];
            return ret;
        },
        __wbg_instanceof_ArrayBuffer_a99f175873e5d9b8: function(arg0) {
            let result;
            try {
                result = arg0 instanceof ArrayBuffer;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Map_b2611749102d7ba3: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Map;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Uint8Array_828cef2aaacafc31: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Uint8Array;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_isArray_e15a2ff68ffdbef2: function(arg0) {
            const ret = Array.isArray(arg0);
            return ret;
        },
        __wbg_isSafeInteger_717808ad6a54bd9e: function(arg0) {
            const ret = Number.isSafeInteger(arg0);
            return ret;
        },
        __wbg_iterator_e3c31c892080e444: function() {
            const ret = Symbol.iterator;
            return ret;
        },
        __wbg_length_7f3c00c40364105e: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_length_d4bdea10311bd9cf: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_new_1dbf7428bba60a42: function(arg0) {
            const ret = new Uint8Array(arg0);
            return ret;
        },
        __wbg_new_28744009d011f847: function() {
            const ret = new Map();
            return ret;
        },
        __wbg_new_617a8cdb8bb1130e: function() {
            const ret = new Object();
            return ret;
        },
        __wbg_new_ee2291f50781bf1d: function() {
            const ret = new Array();
            return ret;
        },
        __wbg_next_33784799010f1bbe: function(arg0) {
            const ret = arg0.next;
            return ret;
        },
        __wbg_next_f4aac29c42af995c: function() { return handleError(function (arg0) {
            const ret = arg0.next();
            return ret;
        }, arguments); },
        __wbg_now_aa4ccb83129e9e55: function() {
            const ret = Date.now();
            return ret;
        },
        __wbg_prototypesetcall_bc27214492979395: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
        },
        __wbg_set_6ae97e73113c4f0b: function(arg0, arg1, arg2) {
            const ret = arg0.set(arg1, arg2);
            return ret;
        },
        __wbg_set_6be42768c690e380: function(arg0, arg1, arg2) {
            arg0[arg1] = arg2;
        },
        __wbg_set_bea140a88be9b277: function(arg0, arg1, arg2) {
            arg0[arg1 >>> 0] = arg2;
        },
        __wbg_value_f3c585ee8f5ba40c: function(arg0) {
            const ret = arg0.value;
            return ret;
        },
        __wbindgen_generic_0000000000000001: function(arg0) {
            // Cast intrinsic for `F64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_generic_0000000000000002: function(arg0) {
            // Cast intrinsic for `I64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_generic_0000000000000003: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_generic_0000000000000004: function(arg0) {
            // Cast intrinsic for `U64 -> Externref`.
            const ret = BigInt.asUintN(64, arg0);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./fluveria_engine_wasm_bg.js": import0,
    };
}

const ArcCpuSamplerDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_arccpusamplerdata_free(ptr, 1));
const ArcGpuBufferDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_arcgpubufferdata_free(ptr, 1));
const ArcQueryDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_arcquerydata_free(ptr, 1));
const BehaviorRuntimeHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_behaviorruntimehandle_free(ptr, 1));
const CompiledShapeDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_compiledshapedata_free(ptr, 1));
const DataProgramHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_dataprogramhandle_free(ptr, 1));
const DataSourceStoreHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_datasourcestorehandle_free(ptr, 1));
const EventProgramHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_eventprogramhandle_free(ptr, 1));
const GraphRuntimeHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_graphruntimehandle_free(ptr, 1));
const LayerShaderResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_layershaderresult_free(ptr, 1));
const QueryProgramHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_queryprogramhandle_free(ptr, 1));
const RuntimeStateHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_runtimestatehandle_free(ptr, 1));
const ScenePainterFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scenepainter_free(ptr, 1));
const ShapeGraphCompileResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_shapegraphcompileresult_free(ptr, 1));
const ShapeLeafHandleDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_shapeleafhandledata_free(ptr, 1));
const ShapeTreePlanDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_shapetreeplandata_free(ptr, 1));
const TextParagraphArcQueryDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_textparagrapharcquerydata_free(ptr, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function getArrayF32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayF64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}

function getArrayU32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let cachedFloat32ArrayMemory0 = null;
function getFloat32ArrayMemory0() {
    if (cachedFloat32ArrayMemory0 === null || cachedFloat32ArrayMemory0.byteLength === 0) {
        cachedFloat32ArrayMemory0 = new Float32Array(wasm.memory.buffer);
    }
    return cachedFloat32ArrayMemory0;
}

let cachedFloat64ArrayMemory0 = null;
function getFloat64ArrayMemory0() {
    if (cachedFloat64ArrayMemory0 === null || cachedFloat64ArrayMemory0.byteLength === 0) {
        cachedFloat64ArrayMemory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachedFloat64ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint32ArrayMemory0 = null;
function getUint32ArrayMemory0() {
    if (cachedUint32ArrayMemory0 === null || cachedUint32ArrayMemory0.byteLength === 0) {
        cachedUint32ArrayMemory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32ArrayMemory0;
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getUint32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayF32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getFloat32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayF64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    getFloat64ArrayMemory0().set(arg, ptr / 8);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasmInstance, wasm;
function __wbg_finalize_init(instance, module) {
    wasmInstance = instance;
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedFloat32ArrayMemory0 = null;
    cachedFloat64ArrayMemory0 = null;
    cachedUint32ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (!module.ok) {
            throw new Error(`failed to fetch Wasm: ${module.status} ${module.statusText} fetching '${module.url}'`);
        }

        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('fluveria_engine_wasm_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
